export const decodeJWT = (token) => {
  if (!token) return null;
  try {
    const base64 = token.split(".")[1];
    const decoded = JSON.parse(atob(base64));
    return decoded;
  } catch (err) {
    console.error("JWT Decode Error:", err);
    return null;
  }
};
